export default "__VITE_ASSET__BNKX_4Od__"